export default "__VITE_ASSET__BLfZ0ru3__"